import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Setor } from 'src/app/classes/Setor';
import { SetorService } from 'src/app/services/setor.service';
import { StorageService } from 'src/app/services/storage.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { ColumnModel, PageSettingsModel, GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { finalize } from 'rxjs/operators';
import { FormsSetorComponent } from './forms-setor/forms-setor.component';
import { FazendaService } from 'src/app/services/fazenda.service';
import { Fazenda } from 'src/app/classes/Fazenda';
import * as moment from 'moment';

@Component({
  selector: 'app-setor',
  templateUrl: './setor.component.html',
  styleUrls: ['./setor.component.scss'],
})
export class SetorComponent implements OnInit {

  @ViewChild("gridSetores", { static: false })
  gridSetores: SyncGridComponent;

  @ViewChild("FormsSetor", { static: false })
  formsSetor: FormsSetorComponent;

  setores: Setor[] = [];
  auxSetores: Setor[];
  setor: Setor;
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;
  isSuper: boolean = false;

  form: any;
  public isSubmit: boolean;
  textoBusca: string = "";
  perfilLogado: number = 0;

  setorColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false
  removendo: boolean = false
  inativando: boolean = false
  duplicando: boolean = false
  gridHeight: string = '79vh';
  fazendas: Fazenda[] = [];

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };

  groupSettings: GroupSettingsModel = {
    columns: ['FazendaNome']
  };

  FEITO: string = "Feito!";
  ERRO: string = "Erro!";
  CANCELAR: string = "Cancelar";
  SIM: string = "Sim";
  CONFIRMAR_DELETE: string = "Se deletar, esta ação não poderá ser desfeita!";
  DELETAR_PARAM: string;
  SETOR_DELETADO: string = "Setor deletado!";
  SETOR_CADASTRADO: string = "Setor cadastrado!";
  SETOR_ALTERADO: string = "Setor alterado!";

  constructor(private setorService: SetorService,
    private utils: UtilsService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private translate: TranslateService,
    private location: Location,
    private fazendaService: FazendaService) {
  }

  ngOnInit() {
    // Verificar se a empresa usa setores
    const empresa = this.storageService.getEmpresa();
    if (!empresa || !empresa.UsaSetores) {
      // this.utils.handleWarning("Esta funcionalidade não está disponível para esta empresa.");
      this.utils.handleWarningSwal("Aviso", "Esta funcionalidade não está disponível para esta empresa.");
      this.router.navigate(['/mapa']);
      return;
    }

    var usuarioLogado = this.storageService.getUsuario();
    this.isSuper = usuarioLogado.isSuper;
    this.perfilLogado = usuarioLogado.Perfil;
    this.setor = new Setor();

    this.listarFazendas();
    this.configurarGrid();
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
      const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
      const title = document.querySelector('app-setor h5.titulo') as HTMLElement
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement

      if (!navbar || !toolbar || !title || !pager) {
        return;
      }

      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;

      const altura = window.innerHeight - navbar.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - title.offsetHeight - pager.offsetHeight - 70
      this.gridHeight = `${altura}px`
    }, 100);
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.pageSettings.pageSize = 20;
    else this.pageSettings.pageSize = 40
    this.pageSettings.pageSize
    this.setorColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false },
      {
        field: "FazendaNome",
        type: "string",
        headerText: "Fazenda",
        allowSorting: true,
        allowGrouping: true,
      },
      {
        field: "Descricao",
        type: "string",
        headerText: "Descrição",
        allowSorting: true,
      },
      // {
      //   field: "Irrigado",
      //   headerText: "Irrigado",
      //   allowSorting: true,
      //   disableHtmlEncode: false,
      //   type: 'boolean',
      //   valueAccessor: (_field: string, _data: any): any => {
      //     return this.badgeIrrigado(_data.Irrigado);
      //   }
      // } as ColumnModel,
      {
        field: "dataAlteracaoStr",
        type: "string",
        headerText: "Ult. Mod.",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      } as ColumnModel,
    ]
  }

  doubleClick(event): void {
    this.editar(event)
  }

  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  badgeIrrigado(irrigado: boolean): string {
    return irrigado ? '<span class="badge badge-light-primary custom-badge-grid">Irrigado</span>' : '<span class="badge badge-light-secondary custom-badge-grid">Sequeiro</span>'
  }

  selecionarSetor() {
    this.ERRO = this.translate.instant("ERRO");

    this.carregando = true;
    this.setorService.getSetor(this.id).subscribe(res => {
      this.setor = new Setor();
      this.setor = res;
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  listarFazendas(): void {
    this.fazendaService.getFazendas().subscribe(
      (res: Fazenda[]) => {
        this.fazendas = res;
        this.listarSetores();
      },
      err => {
        this.utils.getErro(err);
      }
    );
  }

  enriquecerSetoresComFazenda(): void {
    // Adiciona o nome da fazenda em cada setor para permitir agrupamento
    this.setores.forEach(setor => {
      if (setor.FazendaId) {
        const fazenda = this.fazendas.find(f => f.Id === setor.FazendaId);
        setor['FazendaNome'] = fazenda ? fazenda.Nome : 'Não possui';
      } else {
        setor['FazendaNome'] = 'Não possui';
      }
    });
  }

  listarSetores() {
    this.ERRO = this.translate.instant("ERRO");
    this.carregando = true;
    this.setorService.listarTodos()
      // this.setorService.getSetores()
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        (res: Setor[]) => {
          this.setores = res.map(u => Object.assign(new Setor(), u));;
          this.enriquecerSetoresComFazenda();
          if (!this.inserindo)
            this.auxSetores = res;
          if (this.textoBusca != '')
            this.filtrarSetores();
        },
        err => {
          this.utils.getErro(err);
        })
  }

  novo(): void {
    // if(!this.utils.verificarPermissaoUsuario('IncluirSetor'))
    //   return;

    this.formsSetor.abrirModal();
  }

  editar(setor: Setor): void {
    let set;
    if (!setor) {
      var setores = this.gridSetores.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      set = { ...setores[0] };
    }
    else
      set = { ...setor }
    this.formsSetor.abrirModal(set);
  }

  ValidarSelectApenasUm(): boolean {
    var setores = this.gridSetores.getSelectedRecords();
    if (setores.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (setores.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var setores = this.gridSetores.getSelectedRecords();
    if (setores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaDuplicar(): void {
    var setores = this.gridSetores.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os setores selecionados serão duplicados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar setores",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(setores);
      }
    });
  }

  duplicar(setores: Setor[]): void {
    this.duplicando = true
    this.setorService.duplicar(setores.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Setores duplicados com sucesso")
        this.listarSetores();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais()) return
    var setores = this.gridSetores.getSelectedRecords();
    if (setores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todosInativos = setores.every(s => s.Ativo === false);
    const algumInativo = setores.some(s => s.Ativo === false);

    if (todosInativos) {
      this.utils.handleWarning("Todos os setores selecionados já estão inativos");
      return;
    }

    let texto = "Os setores selecionados serão inativados!";
    if (algumInativo) {
      texto += '<br> Alguns setores já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar setores",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(setores);
      }
    });
  }

  inativar(setores: Setor[]): void {
    this.inativando = true;
    this.setorService.inativar(setores.map(p => p.Id))
      .subscribe((res) => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais equipamentos falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = setores.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Setores',
            html: `Os seguintes setores não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else if (setores.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          setores.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar setores',
            html: `os seguintes setores não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("Setores inativados com sucesso");
        }
        this.listarSetores();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  finalizarSaveSetor(): void {
    this.listarSetores();
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirSetores'))
      return;
    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.SETOR_DELETADO = this.translate.instant("SETOR_DELETADO");

    var setores = this.gridSetores.getSelectedRecords();
    if (setores.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os Setores selecionados serão excluídos, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerSetores(setores)
    });
  }

  removerSetores(setores: Setor[]) {
    this.removendo = true;
    this.setorService.deleteSetores(setores.map(p => p.Id)).subscribe(
      res => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais setores falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const setor = setores.find(s => s.Id.toString() === id);
            const nomeSetor = setor ? setor.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeSetor}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir setores',
            html: `Os seguintes setores não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os setores foram excluídos
          this.utils.handleSuccess("Setores excluídos com sucesso");
        }

        this.listarSetores();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });
  }

  filtrarSetores() {
    this.setores = this.auxSetores.map(u => Object.assign(new Setor(), u));
    this.enriquecerSetoresComFazenda();
    this.setores = this.setores.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase()) ||
      (x['FazendaNome'] && x['FazendaNome'].toUpperCase().includes(this.textoBusca.toUpperCase()))
    );
  }

  cancelar() {
    this.router.navigate(['/cadastros/setor']);
  }
}

